// Note: this file is separate from ./models/utils.ts to prevent a dependency cycle

import {COMPUTED_LIST_PROPERTIES_VALUES} from 'common/query-builder/query-block/properties-menu/constants';
import {assert} from 'common/util';

import type {PropertyFilter} from './models/property-filter';

export function isEnhancedListFilter(filter: PropertyFilter): boolean {
  return Array.isArray(filter.listItemFilters) || Boolean(filter.listQuantifier);
}

export function isListOfObjectsFilter(filter: PropertyFilter): boolean {
  return Boolean(filter.listItemFilters);
}

export function hasComputedListFilters(filter: PropertyFilter): boolean {
  return filter.listItemFilters?.some(isComputedListPropertyFilter) ?? false;
}

export function isComputedListPropertyFilter(filter: PropertyFilter) {
  assert(Array.isArray(filter.propertyName) === false, `multiple property names not supported for list of objects`);
  return COMPUTED_LIST_PROPERTIES_VALUES.has(filter.propertyName);
}
